<header
  class="fixed top-0 left-0 z-50 flex flex-row items-center justify-start w-full px-10 bg-white border-solid shadow h-70 dark:bg-gray-darkest dark:shadow-none dark:border-b dark:border-gray-dark lg:px-20"
  @fadeIn>
  <div class="w-1/3">
    <div class="flex items-center gap-x-20 sm:hidden">
      <button class="icon-button is-primary is-inverted" mat-button (click)="acmPortalSidenav.toggle()">
        <mat-icon svgIcon="menu"></mat-icon>
      </button>
      <img class="block w-auto h-50" src="assets/images/logos/alphastar-full%20logo-mint.png" alt="Alphastar Portal">      
    </div>
    @if (!loading) {
    <a class="items-start justify-center hidden m-10 mr-auto uppercase sm:flex max-w-256 hover:no-underline focus:no-underline text-ferra"
      routerLink="/" aria-label="Dashboard">
      <img class="hidden w-auto h-50 sm:block" src="assets/images/logos/alphastar-full%20logo-mint.png" alt="Alphastar Portal">    
    </a>
    }
  </div>
  <div class="w-2/3">
      @for (banner of notificationBanners; track banner) {
       @if (banner.Type === 'new releases' && banner.Show) {
          <app-message-notification panelType="new" [showPanelIcon]=true class="justify-center hidden sm:flex">     
              We're happy to announce enhanced Contribution & Distribution request workflows.  Check out our new
              <a (click)="openReleaseNotesModal()" class="text-sm font-semibold underline cursor-pointer text-m text-blue-dark hover:text-blue-darker">
              RELEASE NOTES</a> page for more information!           
          </app-message-notification>
       }
       @if (banner.Type === 'system message' && banner.Show) {
          <app-message-notification panelType="alert" [showPanelIcon]=true class="justify-center hidden sm:flex">     
            Single sign-on to Orion Advisor Solutions is currently unavailable. In the meantime, please log in directly at <a target="_blank" href="https://login.orionadvisor.com/login.html">Orion Advisor Solutions Login Page</a>. We're working with the vendor to restore SSO and will let you know once it's back online.   
          </app-message-notification>
       }
       
      }                        

    <!-- <app-message-notification panelType="new" [showPanelIcon]=true class="justify-center hidden sm:flex">     
        We're happy to announce new data integrations with our custodian partners.  Check out our 
        <a (click)="openReleaseNotesModal()" class="text-sm font-semibold underline cursor-pointer text-m text-blue-dark hover:text-blue-darker">
        RELEASE NOTES</a> page for more information!           
    </app-message-notification> -->
    <!-- <span @fadeIn class="flex items-center justify-center p-10 border border-solid rounded gap-x-10 border-blue-lighter bg-blue-lightest text-gray-dark">
      <i class="flex-none text-blue-light material-icons mi-18">new_releases</i>      
      <span class="text-sm">
        <strong>New Updates Released!</strong>&nbsp;&nbsp;
        <a (click)="openReleaseNotesModal()"
          class="text-sm font-semibold underline cursor-pointer text-m text-blue-dark hover:text-blue-darker">
          Learn more</a>
      </span>
    </span> -->
  </div>
  <div class="flex justify-end w-1/3"
    *appShowIfOne="[perm.SubmitContributionRequest, perm.SubmitDistributionRequest, perm.SubmitReallocationRequest, perm.SubmitAccountCloseRequest, perm.SubmitPlanningDeskRequest, perm.SubmitMessageFile, perm.SubmitNewPaperAccount]">
    <div class="items-center my-10 ml-auto xs:flex">
      <ng-container>
        <button class="mr-20 button is-mint" mat-button [matMenuTriggerFor]="quickLinksMenu">
          <span class="flex items-center justify-center">
            <span class="ml-5">Quick Links</span><i class="fig-18px fig-triangle-down-filled"></i>
          </span>
        </button>
      </ng-container>
      <mat-menu #quickLinksMenu="matMenu">
        <div class="flex flex-col items-start gap-y-10">
          <ng-container *appHideIfOne="perm.ViewOrionElementProposals">
            <ng-container *appShowIfOne="[perm.ViewSchwabAdvisorCenterSso, perm.SubmitNewPaperAccount]">
              <button mat-menu-item class="flex items-center justify-start min-w-220 button is-lg is-inverted"
                aria-label="Open TDA Institutional Account" [matMenuTriggerFor]="openAccountMenu">
                <span>Open an Account</span>
              </button>
              <mat-menu #openAccountMenu="matMenu">
                <div class="flex flex-col items-start gap-y-10">
                  <ng-container *appShowIfOne="perm.ViewSchwabAdvisorCenterSso">
                    <button mat-menu-item class="flex items-center justify-start min-w-220 button is-lg is-inverted"
                      aria-label="Open Schwab Account Opening"
                      onClick="window.open('api/sso/schwab?destination=ACCT_MNGT')">
                      <span>Launch Schwab Account Opening</span>
                    </button>
                  </ng-container>
                  <ng-container *appShowIfOne="perm.SubmitNewPaperAccount">
                    <button mat-menu-item class="flex items-center justify-start min-w-220 button is-lg is-inverted"
                      aria-label="Open paper application" (click)="openPaperAccountModal()">
                      <span>Paper Application</span>
                    </button>
                  </ng-container>
                </div>
              </mat-menu>
            </ng-container>
          </ng-container>
          <ng-container *appShowIfOne="perm.ViewOrionElementProposals">
            <a mat-menu-item class="flex items-center justify-start min-w-220 button is-lg is-inverted"
              (click)="openOrionAgentSelectModal('ap_proposals')" aria-label="Orion Advisor Portal - Account Opening">
              <span>Open an Account</span>
            </a>
          </ng-container>
          <ng-container *appShowIfOne="[perm.ViewOrionElementRequests]">
            <button mat-menu-item class="flex items-center justify-start min-w-220 button is-lg is-inverted"
              aria-label="Submit New Request" [matMenuTriggerFor]="openOrionMenu">
              <span>Submit Service Request</span>
            </button>
            <mat-menu #openOrionMenu="matMenu">
              <div class="flex flex-col items-start gap-y-10">

                <ng-container>
                  <button mat-menu-item class="flex items-center justify-start min-w-220 button is-lg is-inverted"
                    (click)="openOrionAgentSelectModal('ap_requests')" aria-label="Orion Advisor Portal - Contribution">
                    <span>Contribution</span>
                  </button>
                </ng-container>
                <ng-container>
                  <button mat-menu-item class="flex items-center justify-start min-w-220 button is-lg is-inverted"
                    (click)="openOrionAgentSelectModal('ap_requests')" aria-label="Orion Advisor Portal - Distribution">
                    <span>Distribution</span>
                  </button>
                </ng-container>
                <ng-container>
                  <button mat-menu-item class="flex items-center justify-start min-w-220 button is-lg is-inverted"
                    (click)="openAccountUpdateModal()" aria-label="Model Allocation / Trade">
                    <span>Model Allocation/Trade</span>
                  </button>
                </ng-container>
                <ng-container>
                  <button mat-menu-item class="flex items-center justify-start min-w-220 button is-lg is-inverted"
                    (click)="openOrionAgentSelectModal('ap_requests')"
                    aria-label="Orion Advisor Portal - Close Account">
                    <span>Close Account</span>
                  </button>
                </ng-container>
              </div>
            </mat-menu>
          </ng-container>
          <ng-container *appHideIfOne="perm.ViewOrionElementRequests">
            <ng-container
              *appShowIfOne="[perm.SubmitContributionRequest, perm.SubmitDistributionRequest, perm.SubmitReallocationRequest, perm.SubmitAccountCloseRequest, perm.SubmitMessageFile]">
              <button mat-menu-item class="flex items-center justify-start min-w-220 button is-lg is-inverted"
                aria-label="Submit New Service Request" (click)="openAccountUpdateModal()">
                <span>Submit New Service Request</span>
              </button>
            </ng-container>
          </ng-container>
          <ng-container *appShowIfOne="perm.SubmitPlanningDeskRequest">
            <button mat-menu-item class="flex items-center justify-start min-w-220 button is-lg is-inverted"
              aria-label="Submit New Portfolio Analysis Desk Request" (click)="openPortfolioRequestModal(portfolioAnalysisCategoryEnum.analysisOfCurrentHoldings)">
              <span>Submit New Portfolio Analysis Desk Request</span>
            </button>
          </ng-container>
          <ng-container *appShowIfOne="perm.SubmitFinancialPlanRequest">
            <button mat-menu-item class="flex items-center justify-start min-w-220 button is-lg is-inverted"
              aria-label="Submit Financial Plan Request" (click)="openPortfolioRequestModal(portfolioAnalysisCategoryEnum.fullFinancialPlan)">
              <span>Submit Financial Plan Request</span>
            </button>
          </ng-container>
        </div>
      </mat-menu>
      <button class="my-10 ml-auto button is-lg is-inverted" mat-button (click)="toggleUserSidenav()">
        <span class="flex flex-row items-center justify-center">
          <span class="flex flex-col leading-tight text-right">
            <span class="text-sm font-bold">{{user?.firstName + ' ' + user?.lastName}}</span>
          </span>
          <span
            class="relative flex flex-row items-center justify-center ml-10 rounded-full bg-gray-lightest w-36 h-36">
            <span class="text-sm font-bold uppercase text-mint-darkest">
              <span>
                {{ user?.firstName?.[0]}}{{ user?.lastName?.[0] }}
              </span>
            </span>
          </span>
        </span>
      </button>
    </div>
  </div>
</header>
<mat-sidenav-container class="relative w-full mt-70" autosize="true">
  @if (!loading) {
  <mat-sidenav class="w-full overflow-hidden xs:w-1/3 sm:shadow sm:w-300 dark:border-gray-dark" position="start"
    [disableClose]="true" #acmPortalSidenav [mode]="acmPortalSidenavConfig.Mode"
    [opened]="acmPortalSidenavConfig.IsOpened">
    <app-main-navigation class="flex flex-col h-full"></app-main-navigation>
  </mat-sidenav>
  }
  <mat-sidenav class="w-full xs:w-1/2 sm:w-300 dark:border-gray-dark" position="end" #userSidenav
    [mode]="userSidenavConfig.Mode" [opened]="userSidenavConfig.IsOpened">
    <app-user-navigation class="flex flex-col h-full"></app-user-navigation>
  </mat-sidenav>
  <mat-sidenav-content class="flex flex-col h-full overflow-hidden acm-portal-body dark:bg-black"
    #acmPortalContainerContent id="acmPortalContatainerContent" [@fadeIn]="!loading">
    <section class="flex-grow overflow-auto">
      <router-outlet></router-outlet>
    </section>
  </mat-sidenav-content>
</mat-sidenav-container>